import { Button } from './Button'
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { DialogProps } from './Dialog.types'

export const Dialog = ({
  title,
  content,
  primaryButtonLabel,
  secondaryButtonLabel,
  open,
  handleClose,
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
  danger = false,
}: DialogProps) => {
  return (
    <div>
      <MUIDialog
        open={open}
        onClose={handleClose}
        slotProps={{ paper: { sx: { width: 420, maxWidth: '95vw' } } }}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!!secondaryButtonLabel && (
            <Button variant="outlined" onClick={handleSecondaryButtonClick}>
              {secondaryButtonLabel}
            </Button>
          )}
          <Button
            color={danger ? 'error' : 'primary'}
            variant="contained"
            onClick={handlePrimaryButtonClick}
          >
            {primaryButtonLabel}
          </Button>
        </DialogActions>
      </MUIDialog>
    </div>
  )
}
